module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_flower_tvb-d395f49feca01c2486437fae934d13d1.jpg";